import React from "react"

function SpeechIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 100 104.8"
      version="1.1"
      viewBox="0 0 100 104.8"
      xmlSpace="preserve"
    >
      <title>Speech</title>
      <path d="M66.7 10c-12.9 0-23.3 10.4-23.3 23.3v3.3L37 52.1c-.2.4-.3.8-.3 1.3 0 1.8 1.5 3.3 3.3 3.3h3.3v6.7c0 5.5 4.5 10 10 10h8.3V90H90V33.3C90 20.4 79.6 10 66.7 10zm20.8 76.8h-23V70.9l-12.2-.1c-2 0-5.9-3.3-6.1-6.5V54.1l-7-.1 6.9-17.3.3-4.9c0-10 9.9-19.1 19.9-19.1 10 0 21.2 9.2 21.2 19.2v54.9zM17.4 71.5c-.4-3-.1-8.8 5.5-14.5.6-.6.6-1.6 0-2.3-.6-.6-1.6-.6-2.3 0-6.6 6.6-6.9 13.6-6.4 17.1.4 3.5 2.3 10.2 10.3 15.1.7.5 1.7.2 2.2-.5.5-.8.2-1.7-.5-2.2-6.8-4.1-8.4-9.7-8.8-12.7z" />
      <path d="M24 70.7c-.3-2.2-.1-6.4 4-10.5.6-.6.6-1.6 0-2.3-.6-.6-1.6-.6-2.3 0-5.1 5.1-5.3 10.4-4.9 13.2s1.8 7.8 7.9 11.6c.7.5 1.7.2 2.2-.5.5-.8.2-1.7-.5-2.2-4.9-3.1-6.1-7.1-6.4-9.3z" />
      <path d="M33.2 63.3c.6-.6.6-1.6 0-2.3s-1.6-.6-2.3 0c-3.5 3.6-3.7 7.3-3.4 9.2.2 1.9 1.3 5.5 5.5 8.1.7.5 1.7.2 2.2-.5.5-.8.2-1.7-.5-2.2-3.1-1.9-3.9-4.5-4-5.8-.2-1.2-.1-3.9 2.5-6.5z" />
    </svg>
  )
}

export default SpeechIcon
